module.exports = __webpack_public_path__ + "c02be4c7d2168af16052f551211d8544.jpg";